import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Geoportal from './pages/Geoportal';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Geoportal />} />
          <Route path="/geoportal" element={<Geoportal />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
